export const Roles = {
    superAdmin: 'superadmin',
    siteAdmin: 'site_admin',
    centralAdmin: 'central_admin',
    defaultUser: 'default_user',
    forward: 'forward',
    reverse: 'reverse',

}

export default Roles


// WEBPACK FOOTER //
// ./src/roles.js